export default "__VITE_ASSET__c094951b__"